import { useQuery } from "@tanstack/react-query"
import { getPitchbookInvestor } from "@/api"
import { PitchbookInvestorData } from "@/types"

export const usePitchbookInvestor = (pbInvestorId?: string) => {
  const query = useQuery<PitchbookInvestorData>({
    queryKey: ["pitchbook-investor", pbInvestorId],
    queryFn: () => getPitchbookInvestor(pbInvestorId!),
    staleTime: 1000 * 60 * 5,
    enabled: !!pbInvestorId,
  })

  return {
    ...query,
    data: query.data || null,
  }
}
